'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var React__namespace = /*#__PURE__*/_interopNamespace(React);

/**
 * Handles the node type of the button, depending
 */
function useButtonType(value) {
  var _React$useState = React__namespace.useState(!value),
    _React$useState2 = _slicedToArray__default["default"](_React$useState, 2),
    isButton = _React$useState2[0],
    setIsButton = _React$useState2[1];
  var refCallback = React__namespace.useCallback(function (node) {
    if (!node) return;
    setIsButton(node.tagName === 'BUTTON');
  }, []);
  var type = isButton ? 'button' : undefined;
  return {
    ref: refCallback,
    type: type
  };
}
exports.useButtonType = useButtonType;